<template>
<ValidationObserver ref="observer">
  <form ref="add_faktur_form" @submit.prevent="addFaktur">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Faktur
        </h4>
      </md-card-header> -->
      <md-card-content>
        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Faktur No. (Read)<span style="color:red">*</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="fakturno" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-input v-model="faktur_no" disabled/>
              <validation-error :errors="apiValidationErrors.faktur_no" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div> -->

        <div class="md-layout" style="margin-top:20px;">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            Faktur Datetime (Read)<span style="color:red"> *</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="datetime" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Faktur Datetime</label>
              <md-input v-model="faktur_invoice_datetime" disabled required/>
              <validation-error :errors="apiValidationErrors.faktur_invoice_datetime" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        <!-- </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            PKB No. (Read)<span style="color:red">*</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="pkbno" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) PKB No</label>
              <md-input type="hidden" readonly v-model="faktur_pkb_id" />
              <md-input v-model="faktur_pkb_no" disabled/>
              <validation-error :errors="apiValidationErrors.faktur_pkb_no" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">SA Contact</span>
          </label> -->
          <div class="md-layout-item md-size-100">
            <validation-provider rules="sacontact" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) SA Contact</label>
              <md-input v-model="faktur_sa_contact" disabled required/>
              <validation-error :errors="apiValidationErrors.faktur_sa_contact" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Date In</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="datein" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Date In</label>
              <md-input v-model="faktur_date_in" disabled required/>
              <validation-error :errors="apiValidationErrors.faktur_date_in" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        <!-- </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Date Out</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="dateout" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Date Out</label>
              <md-input v-model="faktur_date_out" disabled required/>
              <validation-error :errors="apiValidationErrors.faktur_date_out" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">KM In</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="kmin" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">(Read) Kilometer In</label>
              <md-input v-model="faktur_customer_km_in" type="text" v-on:keypress="NumbersOnly" disabled required/>
              <validation-error :errors="apiValidationErrors.faktur_customer_km_in" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        <!-- </div>

        <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">KM Out</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="kmout" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Kilometer Out</label>
              <md-input v-model="faktur_customer_km_out" type="text" v-on:keypress="NumbersOnly" required/>
              <validation-error :errors="apiValidationErrors.faktur_customer_km_out" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field>
            </validation-provider>
          </div>
        </div>
      <div>
        <md-card>
            <md-card-content>
        <div class="md-layout">
          
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Total Biaya Jasa</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">(Read) Total Biaya Jasa</label>
              <md-input v-model="faktur_total_biaya_jasa" type="text" v-on:keypress="NumbersOnly"  disabled/>
              <validation-error :errors="apiValidationErrors.faktur_total_biaya_jasa" />
            </md-field>
          </div>
        <!-- </div>

        <div class="md-layout"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Total Biaya Spare Part</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">(Read) Total Biaya Spare Part</label>
              <md-input v-model="faktur_total_biaya_spare_part" type="text" v-on:keypress="NumbersOnly" disabled/>
              <validation-error :errors="apiValidationErrors.faktur_total_biaya_spare_part" />
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Sub TOTAL</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">(Read) Subtotal</label>
              <md-input v-model="faktur_sub_total" type="text" v-on:keypress="NumbersOnly" disabled/>
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">PPN</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">(Read) PPN</label>
              <md-input v-model="faktur_ppn" type="text" v-on:keypress="NumbersOnly" disabled/>
            </md-field>
          </div>
        <!-- </div>
        <div class="md-layout"> -->
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Materai</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Materai</label>
              <md-input v-model="faktur_materai" type="text" v-on:keypress="NumbersOnly" @change="changeMaterai(faktur_materai)" />
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">TOTAL</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">(Read) Total</label>
              <md-input v-model="faktur_total"  disabled />
            </md-field>
          </div>
        </div>
            </md-card-content>
        </md-card></div>

        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Bahan</span>
          </label>
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <md-input v-model="faktur_bahan" />
              <validation-error :errors="apiValidationErrors.faktur_bahan" />
            </md-field>
          </div>
        </div> -->

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Saran</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Saran</label>
              <md-textarea v-model="faktur_saran" md-counter="100" maxlength="100" md-autogrow></md-textarea>
              <validation-error :errors="apiValidationErrors.faktur_saran" />
            </md-field>
          </div>
        </div>
        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Ketentuan</span>
          </label> -->
          <div class="md-layout-item">
            <md-field class="md-invalid">
              <label for="">Ketentuan</label>
              <md-textarea v-model="faktur_ketentuan" md-counter="100" maxlength="100" md-autogrow></md-textarea>
              <validation-error :errors="apiValidationErrors.faktur_ketentuan" />
            </md-field>
          </div>
        </div>

        <div class="md-layout">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Kasir</span>
          </label> -->
          <div class="md-layout-item">
            <validation-provider rules="kasir" v-slot="{ errors }">
            <md-field class="md-invalid">
              <label for="">Kasir</label>
              <md-select v-model="faktur_kasir" required>
                <md-option v-for="option in options_kasir_list" :key="option.value" :value="option.id">
                  {{ option.name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.faktur_kasir" />
              <span class="md-error">{{ errors[0] }}</span>
            </md-field> 
            </validation-provider>
          </div>
        </div>
      </md-card-content>

      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
  import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import {extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);
//config validation input
  extend('fakturno', {
  ...required,
  message: 'Faktur No. field is required'
});
extend('datetime', {
  ...required,
  message: 'Faktur Datetime field is required'
});
extend('datein', {
  ...required,
  message: 'Date In field is required'
  });
  extend('dateout', {
    ...required,
    message: 'Date Out field is required'
  });
  extend('sacontact', {
    ...required,
    message: 'SA Contact field is required'
  });
  extend('kasir', {
    ...required,
    message: 'Kasir field is required'
  });
  extend('kmin', {
    ...required,
    message: 'KM Out field is required'
  });
  extend('kmout', {
    ...required,
    message: 'KM Out field is required'
  });

  export default {
     name: "add-service-categories",

    props: {
      data_id: Object
    },

    components: {ValidationError , ValidationObserver},

    mixins: [formMixin],

    data: () => ({
      // faktur_no: null,
      faktur_invoice_datetime: null,
      faktur_pkb_id: null,
      faktur_sa_contact: null,
      faktur_date_out: null,
      faktur_saran: null,
      faktur_ketentuan: null,
      faktur_kasir: null,
      faktur_total_biaya_spare_part: null,
      faktur_total_biaya_jasa: null,
      faktur_customer_km_in: null,
      faktur_date_in: null,
      faktur_customer_km_out: null,
      faktur_pkb_no: null,
      faktur_sub_total: 0,
      faktur_ppn: 0,
      faktur_materai: 0,
      faktur_total: 0,
      options_kasir_list: null,
    }),
    
    created() {
      this.getData();
    },

   

    methods: {
      //ambil data yang diperlukan
       async getData(){

        
          //  await this.$store.dispatch("workshop_faktur/last_no")
          //  this.faktur_no =  await this.$store.getters["workshop_faktur/faktur"]
           this.getId()
           //ambil data pkb yang akan digunakan di faktur
           await this.$store.dispatch("workshop_pkb/get",this.data_id.id)
           var pkb = await this.$store.getters["workshop_pkb/pkb"]
            
           //ambil data list kasir
          var query = {"filter":{role:'kasir',pool:pkb.pkb_service_estimate.service_estimate_pool_id}}
            await this.$store.dispatch("users/list",query) 
            this.options_kasir_list = await this.$store.getters["users/list"]


           if(pkb.pkb_service_estimate.sa_name.no_telpon==null){
            this.faktur_sa_contact = pkb.pkb_service_estimate.sa_name.name
            } else { 
             this.faktur_sa_contact = pkb.pkb_service_estimate.sa_name.name +' - '+ pkb.pkb_service_estimate.sa_name.no_telpon
            }
           this.faktur_pkb_no = pkb.pkb_no
           this.faktur_pkb_id = pkb.id
           this.faktur_invoice_datetime =  this.$moment(new Date()).format('YYYY-MM-DD')
           this.faktur_date_in = pkb.pkb_service_estimate.service_estimate_create_at_datetime
           this.faktur_customer_km_in = pkb.pkb_service_estimate.service_estimate_vehicle_km
          this.faktur_customer_km_out = pkb.pkb_service_estimate.service_estimate_vehicle_km
           this.faktur_total_biaya_spare_part = pkb.pkb_nota_part ? pkb.pkb_nota_part.nota_part_total : 0
           this.faktur_total_biaya_jasa = pkb.pkb_nota_service ? pkb.pkb_nota_service.nota_jasa_bkl_total : 0
           this.faktur_date_out =  this.$moment(new Date()).format('YYYY-MM-DD')
           this.faktur_sub_total = parseInt(this.faktur_total_biaya_spare_part) + parseInt(this.faktur_total_biaya_jasa)
           //hitung ppn jika menggunakan ppn saat di se
           if(pkb.pkb_service_estimate.service_estimate_ppn == 0){
             this.faktur_ppn =  (this.faktur_sub_total * 11) / 100
           }
           this.faktur_total = this.faktur_sub_total + this.faktur_ppn 
        // this.$refs.procurement_order_no_input.$el.focus();
        // this.$refs.procurement_order_remark_input.$el.focus();

          
      },

      NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
      //fungsi ketika ada perubahan di input materai
      changeMaterai(data){
        //hitung total
        this.faktur_total = this.faktur_sub_total + this.faktur_ppn + parseInt(data)
      },

      async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addFaktur()
        }
      });
    },

      //fungsi untuk mengirim data ke server api
      async addFaktur() {
       

        const data = {
          type: "workshop_fakturs",
          // faktur_no: this.faktur_no,
          faktur_invoice_datetime: this.faktur_invoice_datetime,
          faktur_pkb_id: this.faktur_pkb_id,
          faktur_sa_contact: this.faktur_sa_contact,
          faktur_date_in: this.faktur_date_in,
          faktur_date_out: this.faktur_date_out,
          faktur_customer_km_in: this.faktur_customer_km_in,
          faktur_customer_km_out: this.faktur_customer_km_out,
          faktur_total_biaya_jasa: this.faktur_total_biaya_jasa,
          faktur_total_biaya_spare_part: this.faktur_total_biaya_spare_part,
          faktur_ppn: this.faktur_ppn,
          faktur_materai: this.faktur_materai,
          faktur_ketentuan: this.faktur_ketentuan,
          faktur_saran: this.faktur_saran,
          faktur_kasir: this.faktur_kasir
        }
 

        try {
          //kirim data ke api
        await this.$store.dispatch("workshop_faktur/add", data);
        //panggil alert  sukses
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        //kembali ke list
        // await this.$router.push({name: 'List Faktur'});
        this.$parent.$parent.modalCloseCreateFaktur();
      } catch (e) {
        //pangil alert gagal
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }

      },
      getId(){
        if(this.$route.name == "Add Faktur" && this.$route.query.pkb_id){
          this.faktur_pkb_id = this.$route.query.pkb_id
        }
      }
    },
    mounted() {
        console.log('Component mounted.')
        this.getId()
    }
  };
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>